import React, { Component } from 'react';

class Ads extends Component {

    render() {
        return (
            <div className="ads-area pd-top-90 pd-bottom-70 viaje-go-top">
                
                <style>{`
                    .btn-whatsapp-hero {
                        background-color: #25D366;
                        border: none;
                        display: inline-flex !important;
                        align-items: center;
                        justify-content: center;
                        height: auto !important;
                        line-height: 1.2 !important;
                        padding: 18px 45px !important; /* Um pouco maior aqui para chamar atenção */
                        font-size: 20px;
                        font-weight: 700;
                        border-radius: 50px;
                        box-shadow: 0 10px 20px rgba(37, 211, 102, 0.3);
                        transition: all 0.3s ease;
                        width: auto !important;
                        max-width: 100%;
                        color: #fff !important;
                        text-decoration: none;
                    }
                    
                    .btn-whatsapp-hero:hover {
                        background-color: #1da851;
                        transform: translateY(-5px);
                        box-shadow: 0 15px 30px rgba(37, 211, 102, 0.4);
                        color: #fff !important;
                    }

                    @media (max-width: 768px) {
                        .btn-whatsapp-hero {
                            width: 100% !important;
                            padding: 15px 20px !important;
                            font-size: 16px;
                        }
                    }
                `}</style>

                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8 col-lg-9 text-center">
                            
                    

                           
                            <div className="ads-btn-wrap">
                                <a 
                                    href="https://wa.me/5511930766388" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="btn btn-primary btn-whatsapp-hero"
                                >
                                    <i className="fa fa-whatsapp" style={{ marginRight: '10px', fontSize: '24px' }}></i>
                                    Quero planejar minha viagem
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Ads;